import React, { useEffect, useState } from "react";
import "./Objectives.css";
import { Col, Container, Row } from "react-bootstrap";
import picture1 from "../../Assets/newAssets/Picture1.png";
import picture2 from "../../Assets/newAssets/Picture2.png";
import picture3 from "../../Assets/newAssets/Picture3.png";
import picture4 from "../../Assets/newAssets/Picture4.png";
import picture5 from "../../Assets/newAssets/Picture5.png";
const Objectives = () => {
  const [width, setWidth] = useState(window.innerWidth);
  const content = [
    {
      title: "Design Philosophy",
      img: picture1,
      // body: "Exceptional architecture blends purpose, aesthetics, and experience. Our designs prioritize function, celebrate detail, and capture each space’s unique essence.",
      body: "We design with intention-honouring functionality, celebrating thoughtful details, and bringing out the true character of every space",
    },
    {
      title: "Specifics",
      img: picture2,
      // body: "We provide complete architecture services—residential, commercial, and interior—crafting spaces that are both harmonious and visually striking.",
      body: " We offer complete architectural services—residential, commercial, and interior—shaping spaces that feel balanced and visually compelling",
    },
    {
      title: "Detailing",
      img: picture3,
      // body: "We believe every detail matters. Our meticulous approach ensures each design exceeds expectations",
      body: "We believe every detail has a purpose. With a thoughtful, careful approach, we shape designs that feel complete, considered, and truly exceed expectations.",
    },
    {
      title: "Creativity",
      img: picture4,
      // body: "Our expertise blends innovation, functionality, and aesthetics—transforming spaces from concept to creation with passion, precision, and architectural finesse.",
      body: "Our expertise brings together innovation, functionality, and timeless aesthetics—shaping every space from concept to completion with passion, precision, and true architectural care.",
    },
    {
      title: "Client Satisfaction",
      img: picture5,
      // body: "We design functional, visually appealing spaces that reflect our clients' vision, with satisfaction at the core of every project.",
      body: "We create functional, beautiful spaces that stay true to our clients’ vision, placing their satisfaction at the heart of every project.",
    },
  ];
  const mobContent1 = [content[0], content[1], content[2]];
  const mobContent2 = [content[3], content[4]];
  console.log(mobContent1)
  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <div className="objectives">
      <div className="title">
        <h1>OBJECTIVES</h1>
      </div>
      <Container>
        <Row>
          {width >= 1200 && (
            <div className="objectivesBody">
              {content.map((item, index) => (
                // <Col lg={3}>
                <div className="flipCard" key={item.title}>
                  <div className="flipCardInner">
                    <div className="flipCardFront">
                      <div>
                        <img
                          height={140}
                          width="auto"
                          src={item.img}
                          alt={item.title}
                        />
                      </div>
                    </div>
                    <div className="flipCardBack">
                      <div className="flipCardTitle">{item.title}</div>
                      {item.body}
                    </div>
                  </div>
                </div>
                // </Col>
              ))}
            </div>
          )}
          {width < 1200 && (
            <div className="mobjectivesBody">
              <div className="mob1container">
                {mobContent1.map((item, index) => (
                  // <Col lg={3}>
                  <div className="flipCard" key={item.title}>
                    <div className="flipCardInner">
                      <div className="flipCardFront">{item.title}</div>
                      <div className="flipCardBack">{item.body}</div>
                    </div>
                  </div>
                  // </Col>
                ))}
              </div>
              <div className="mob2container">
                {mobContent2.map((item, index) => (
                  // <Col lg={3}>
                  <div className="flipCard" key={item.title}>
                    <div className="flipCardInner">
                      <div className="flipCardFront">{item.title}</div>
                      <div className="flipCardBack">{item.body}</div>
                    </div>
                  </div>
                  // </Col>
                ))}
              </div>
            </div>
          )}
        </Row>
      </Container>
    </div>
  );
};

export default Objectives;
